import React, { type ReactNode } from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { createStyles } from '@/hooks';
import { colors } from '@/theme/colors';

type InputLabelProps = {
  children: ReactNode;
  /** Append a red `*` to mark the field as required. */
  required?: boolean;
};

/** Field label for auth inputs, optionally with a required `*` (matches Figma input labels). */
export function InputLabel({ children, required }: InputLabelProps) {
  const styles = useStyles();
  return (
    <Stack direction="row" align="center" gap={2}>
      <Text variant="Font Guardian App/Subtitle/Subtitle 12 Semibold" style={styles.label}>
        {children}
      </Text>
      {required ? (
        <Text variant="Font Guardian App/Subtitle/Subtitle 12 Semibold" style={styles.required}>
          *
        </Text>
      ) : null}
    </Stack>
  );
}

const useStyles = createStyles(() => ({
  label: {
    color: colors['10'],
  },
  required: {
    color: colors.Error,
  },
}));

export default InputLabel;
